module.exports = __webpack_public_path__ + "img/Pop-up_11.9bb10a27.png";